export default __webpack_public_path__ + "static/Calibre-Medium-46693d9b57a6b8a657b5393258f6e899.woff";